import {swiperInit} from './swiperInit';

export const articleListSwiper = (() => {
  swiperInit({
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
    },
    selector: '.articleListSwiper',
  })
})();
